import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import {
  requestTranscriptionEnablement,
  requestTranscriptionDisablement,
} from "@/Services/TherapyApi/Clients";
import TranscriptionTransformer, {
  type TranscriptionTransformerType,
} from "@/Modules/Transformers/Patients/Transcription";

import useAppStore from "@/Modules/App/Store";
import usePatientsStore from "@/Modules/Patients/Store";

import { hasValue } from "@/Utils/Objects";

async function requestTranscriptionAH(isTranscriptionEnableRequested: boolean): Promise<boolean | undefined> {
  const appStore = useAppStore();
  const patientsStore = usePatientsStore();

  if (!hasValue(patientsStore.selected)) return false;

  try {
    const transcriptionApi = isTranscriptionEnableRequested
      ? await requestTranscriptionEnablement(patientsStore.selected.uuid)
      : await requestTranscriptionDisablement(patientsStore.selected.uuid);
    const transcriptionTransformer: TranscriptionTransformerType = TranscriptionTransformer;
    const transcriptionDomain = transcriptionTransformer.toDomain(transcriptionApi);

    patientsStore.selected.transcription = transcriptionDomain;

    appStore.showSnackbar({
      message: "patients.clinical_documentation.transcription.saved_notification",
      type: NotificationType.SUCCESS,
    });

    return true;
  } catch (error: unknown) {
    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message: "patients.clinical_documentation.transcription.error_notificacion",
    });

    return false;
  }
}

export default requestTranscriptionAH;
